module.exports = __webpack_public_path__ + "img/kv-sp_x2.acfa79e.webp";